module.exports = __webpack_public_path__ + "img/voyage.92fc1f26.png";